import React from 'react';
import { Grid, Typography, Container } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import { EmployeeRow } from '@components/molecules';
import { CardBase } from '@components/organisms';
import { isMobile } from 'react-device-detect';

const useStyles = makeStyles(theme => ({
    container: {
        [theme.breakpoints.up('sm')]: {
            overflowY: 'scroll',
            height: 440,
        },
        width: '100%',
    },
    itemContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingRight: theme.spacing(6),
        paddingLeft: theme.spacing(6),
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(1),
    },
    card: {
        height: '15%',
        backgroundColor: theme.palette.background.default,
        marginBottom: theme.spacing(1),
    },
}));

const SearchResults = ({ filteredData, noResults, handleOnClick }) => {
    const classes = useStyles();
    
    return (
        <>
            {filteredData.length > 0 && (
                <>
                    <Grid item sm={12}>
                        <Typography variant="subtitle2">Total Results: {filteredData.length}</Typography>
                    </Grid>
                    {!isMobile && (
                        <Container className={classes.itemContainer}>
                            <Grid item sm={2}>
                                <Typography variant="subtitle2">Employee ID</Typography>
                            </Grid>
                            <Grid item sm={5}>
                                <Typography variant="subtitle2">Employee Name</Typography>
                            </Grid>
                            <Grid item sm={4}>
                                <Typography variant="subtitle2">Job Title</Typography>
                            </Grid>
                            <Grid item sm={1}>
                                <Typography variant="subtitle2">BU #</Typography>
                            </Grid>
                        </Container>
                    )}
                    <Grid item sm={12} spacing={4} className={classes.container}>
                        {filteredData.length > 0 && filteredData.map((data) => (
                            <CardBase
                                liftUp
                                onClick={() => handleOnClick(data)}
                                className={classes.card}
                            >
                                <EmployeeRow data={data} />
                            </CardBase>
                        ))}
                        {noResults && (
                            <div>No Results</div>
                        )}
                    </Grid>
                </>
            )}
        </>
    )
}

export default SearchResults;
